module.exports = __webpack_public_path__ + "static/media/kfc.911151f0.webp";